export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "contextWorker.afc05082.worker.js");
}
